import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Card,
  message,
  Spin,
  List,
} from "antd";
import {
  baseUrl,
  HEADERS_EXPORT,
  POST_EXPENSES,
  POST_EXPENSES_REFERENCE,
  PUT_INVESTIGATE_ITEM_BY_ID,
  PUT_JUDGE,
  PUT_LAWSUIT_DETAIL,
  PUT_STATUS,
} from "../../../API/apiUrls";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import DateCustom from "../../../../hook/DateCustom";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
// import EditAdvancePaymentDetail from "./EditAdvancePaymentDetail";
import {
  DELIVERY_OF_SUMMONS,
  DOCUMENT_COST,
  FEE_COURT,
  PAYADVANCE_STATUS_PROCESS,
  STAMP_COST,
  STATUS_WITHDRAW_PROCESS,
  STATUS_WITHDRAW_SUCCESSFUL,
} from "../../../../utils/constant/ExpenseType";
import { optionsLone } from "../../../../utils/constant/LoanTypeConstant";
import ExpenseList from "./ExpenseList";
import {
  ENFORCEMENT,
  JUDGEMENT,
  STATUS_PROCESS_PROCESS,
  STATUS_PROCESS_PROCESS_PAYMENT,
} from "../../../../utils/constant/StatusConstant";

const CreateAdvanePayment = ({
  open,
  close,
  dataDefault,
  funcUpdateStatus,
  company,
}) => {
  const USER_ID = localStorage.getItem("USER_ID");
  const [form] = Form.useForm();
  const [convertDateThai] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const { TextArea } = Input;
  const [isModal, setIsModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [arrow, setArrow] = useState("Show");
  const [dataPropertyList, setDataPropertyList] = useState([]);
  const [editPayment, setEditPayment] = useState();
  const [dataExpense, setDataExpense] = useState([]);

  useEffect(() => {
    setIsModal(open);
    if (isModal) {
      setDataPropertyList(dataDefault);
      console.log("loadData---->", dataDefault);
    }
  }, [isModal]);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, []);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
    setIsModal(false);
  };

  const sendData = async (
    setPutInvestigateSeize,
    setPreExpenseSend,
    setReference,
    putStatus = []
  ) => {
    setLoading(true);

    try {
      // ✅ ตรวจสอบความถูกต้องของข้อมูลก่อนส่ง
      const isValid =
        Array.isArray(setPutInvestigateSeize) &&
        Array.isArray(setPreExpenseSend) &&
        !setPutInvestigateSeize.some((item) => !item) &&
        !setPreExpenseSend.some((item) => !item);

      if (!isValid) {
        message.warning("พบค่าที่ไม่ถูกต้อง");
        return;
      }

      // ✅ ส่งข้อมูล putStatus (array)
      const putStatusResponses = await Promise.all(
        putStatus.map((statusItem) =>
          axios.put(`${baseUrl}${PUT_STATUS}`, statusItem, {
            headers: HEADERS_EXPORT,
          })
        )
      );

      const allPutStatusOK = putStatusResponses.every(
        (res) => res.status === 200
      );
      if (!allPutStatusOK) {
        message.error("ไม่สามารถส่งข้อมูลสถานะหลักได้ครบถ้วน");
        return;
      }

      // ✅ อัปเดตสถานะในระบบหลังส่งสำเร็จ
      funcUpdateStatus(putStatus);

      // ✅ เตรียม promises สำหรับ Investigate + Expense + Reference
      const promises = [
        ...setPutInvestigateSeize.map((item) =>
          axios.put(`${baseUrl}${PUT_INVESTIGATE_ITEM_BY_ID}`, item, {
            headers: HEADERS_EXPORT,
          })
        ),
        ...setPreExpenseSend.map((item) =>
          axios.post(`${baseUrl}${POST_EXPENSES}`, item, {
            headers: HEADERS_EXPORT,
          })
        ),
        axios.post(`${baseUrl}${POST_EXPENSES_REFERENCE}`, setReference, {
          headers: HEADERS_EXPORT,
        }),
      ];

      // ✅ ส่งทั้งหมดพร้อมกัน
      const results = await Promise.all(promises);

      // ✅ ตรวจสอบผลลัพธ์
      const allSuccess = results.every(
        (res) => res.status === 200 || res.status === 201
      );

      if (allSuccess) {
        message.success("อัพเดทข้อมูลสำเร็จทั้งหมด");
        console.log("✅ อัพเดทข้อมูลสำเร็จทั้งหมด");
      } else {
        message.error("มีข้อมูลบางรายการอัพเดทไม่สำเร็จ");
        console.warn("⚠️ บางรายการอัพเดทไม่สำเร็จ", results);
      }

      // ✅ หากต้องอัปเดตสถานะเพิ่มหลังจากอัพเดททรัพย์และรายจ่าย
      funcUpdateStatus([...setPutInvestigateSeize]);
    } catch (error) {
      console.error("❌ Error sending data:", error);
      message.error("เกิดข้อผิดพลาดในการอัพเดทข้อมูล");
    } finally {
      setLoading(false);
      handleCancel();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const handleEdit = (item, index) => {
    console.log("item", item, index);
    setEditPayment(dataPropertyList[index]);
    setIsEditModal(true);
  };

  const handleDelete = (index) => {
    Modal.confirm({
      title: "ต้องการลบสัญญานี้ใช่หรือไม่​?",
      okText: "ยืนยัน",
      cancelText: "ปิด",
      onOk: () => {
        console.log("delete--->", index);
        setDataPropertyList((prevData) =>
          prevData.filter((_, i) => i !== index)
        );
      },
    });
  };

  const onFinish = (values) => {
    console.log("values", values);
    console.log(dataPropertyList);
    let setPutInvestigateSeize = [];
    let setPreExpenseSend = [];
    let defindNo;
    let putStatus = [];
    const formatTwoDigit = (num) => (num < 10 ? "0" + num : num);
    if (company.value === 1 || company.value === 4) {
      defindNo = `${ENFORCEMENT}LBN${formatTwoDigit(USER_ID)}${formatTwoDigit(
        dataDefault.length
      )}-${dayjs().format("YYYYMMDDHHmmss")}`;
    } else if (company.value === 2 || company.value === 5) {
      defindNo = `${ENFORCEMENT}MBN${formatTwoDigit(USER_ID)}${formatTwoDigit(
        dataDefault.length
      )}-${dayjs().format("YYYYMMDDHHmmss")}`;
    } else {
      defindNo = `${ENFORCEMENT}KBN${formatTwoDigit(USER_ID)}${formatTwoDigit(
        dataDefault.length
      )}-${dayjs().format("YYYYMMDDHHmmss")}`;
    }

    const dataReference = {
      reference_no: defindNo,
      user_id: USER_ID,
      pay_status_id: PAYADVANCE_STATUS_PROCESS,
    };

    const initDataExpense = {
      withdraw_process_id: STATUS_WITHDRAW_PROCESS,
      withdraw_datetime: null,
      withdraw_mark: values.memo,
      pay_type_id: null,
      pay_datetime: null,
      pay_mark: null,
      file_path: null,
      reference_no: defindNo,
    };

    console.log(" dataPropertyList", dataPropertyList);
    try {
      // วนลูปข้อมูลหลัก (ที่คุณให้มา)
      dataPropertyList.forEach((record) => {
        const investigate_list = [];

        // ✅ 1. push เข้า putStatus
        putStatus.push({
          id: record.WORK_LOG_ID,
          USER_ID: record.LAWYER_ID,
          LOAN_ID: record.id,
          MEMO: values.memo,
          DATE: record.DATE,
          PROCESS_ID: STATUS_PROCESS_PROCESS_PAYMENT,
          LOAN_TYPE_ID: record.LOAN_TYPE_ID,
        });
        // 1. customer_property_list
        (record.customer_property_list || []).forEach((property) => {
          if (property.seize_status === 1) {
            investigate_list.push({ INVESTIGATE_PROPERTY_ID: property.id });
            setPutInvestigateSeize.push({
              ...property,
              seize_status: STATUS_PROCESS_PROCESS,
            });
          }
        });

        // 2. guarantor_property_list
        (record.guarantor_property_list || []).forEach((property) => {
          if (property.seize_status === 1) {
            investigate_list.push({ INVESTIGATE_PROPERTY_ID: property.id });
            setPutInvestigateSeize.push({
              ...property,
              seize_status: STATUS_PROCESS_PROCESS,
            });
          }
        });

        // 3. setPreExpenseSend: สร้างข้อมูลจาก setPreExpense (รายการรายจ่าย)
        (record.setPreExpense || []).forEach((expense) => {
          setPreExpenseSend.push({
            ...initDataExpense,
            ...expense,
            investigate_list,
          });
        });
      });
      console.log("setPutInvestigateSeize", setPutInvestigateSeize);
      console.log(" setPreExpenseSend", setPreExpenseSend);
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาด:", error.message);
      message.error("กรุณาทำรายการเบิกให้ถูกต้อง");
    }
    console.log("status", putStatus);

    console.log("setPutInvestigate", setPutInvestigateSeize);
    console.log("setDataExpense---->", setPreExpenseSend);

    sendData(
      setPutInvestigateSeize,
      setPreExpenseSend,
      dataReference,
      putStatus
    );
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครับ");
  };

  const onChangeInputMemo = (value) => {
    console.log(value);
  };

  const handleUpdateDataEdit = (data) => {
    console.log("data---->update", data);
    if (data) {
      const result = dataPropertyList.map((item) => {
        if (item.CONTNO === data.CONTNO) {
          return { ...data };
        } else {
          return { ...item };
        }
      });
      console.log(result);

      setDataPropertyList(result);
    }
  };

  const renderLoanType = (value) => {
    return (
      optionsLone.find((item) => item.value === value)?.label ||
      "ไม่พบประเภทสัญญา"
    );
  };

  const renderAssets = (data) => {
    if (!data || typeof data !== "object") return 0;

    const customerSeized = (data.customer_property_list || []).filter(
      (item) => item.seize_status === 1
    );

    const guarantorSeized = (data.guarantor_property_list || []).filter(
      (item) => item.seize_status === 1
    );

    const totalSeized = customerSeized.length + guarantorSeized.length;
    console.log("✅ totalSeized", totalSeized);
    return totalSeized;
  };

  const formDataSet = () => {
    return (
      <Form
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 14,
        }}
        form={form}
        layout="horizontal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          memo: null,
        }}
      >
        <Form.Item label="วันที่ทำรายการ" name="dateWithdraw">
          {convertDateThai()}
          {/* <DatePicker onChange={onChangeInputInvestigateDate} /> */}
        </Form.Item>

        <Form.Item
          label="สัญญาที่ต้องการเบิก"
          name="contnoWithdraw"
          labelCol={{ span: 6 }} // กำหนดความกว้างของ label
          wrapperCol={{ span: 16 }} // กำหนดความกว้างของ input หรือ content
        >
          <List
            itemLayout="horizontal"
            dataSource={dataPropertyList}
            renderItem={(item, index) => (
              <List.Item
                actions={[
                  !item?.setPreExpense ? (
                    <Link
                      key="list-loadmore-edit"
                      onClick={() => handleEdit(item, index)}
                    >
                      เพิ่ม
                    </Link>
                  ) : (
                    <Link
                      key="list-loadmore-edit"
                      style={{ color: "orange" }}
                      onClick={() => handleEdit(item, index)}
                    >
                      แก้ไข
                    </Link>
                  ),
                  <Link
                    key="list-loadmore-more"
                    style={{ color: "red" }}
                    onClick={() => handleDelete(index)} // ส่ง index เข้าไปในฟังก์ชัน
                  >
                    ลบ
                  </Link>,
                ]}
              >
                <List.Item.Meta
                  title={
                    <p>
                      {item.CONTNO} ยึด {renderAssets(item)} แปลง
                    </p>
                  }
                  description={
                    <div>
                      {item?.setPreExpense?.map((expense, index) => (
                        <div key={index} style={{ color: "blue" }}>
                          - {expense.label} :{" "}
                          {currencyFormatPoint(expense.withdraw)} บาท
                        </div>
                      ))}

                      {/* รวมยอดทั้งหมด */}
                      <div
                        style={{
                          marginTop: 8,
                          fontWeight: "bold",
                          color: "green",
                        }}
                      >
                        รวมทั้งหมด :{" "}
                        {currencyFormatPoint(
                          item?.setPreExpense?.reduce(
                            (total, expense) =>
                              total + Number(expense.withdraw || 0),
                            0
                          )
                        )}{" "}
                        บาท
                      </div>
                    </div>
                  }
                />

                {/* <div>
                    {" "}
                    {item?.initDataExpense?.withdraw ? "ก่อนฟ้อง" : null}
                  </div> */}
              </List.Item>
            )}
          />
        </Form.Item>

        <Form.Item label="หมายเหตุ" name="memo">
          <TextArea
            rows={5}
            onChange={(e) => onChangeInputMemo(e.target.value)}
          />
        </Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button
            onClick={handleCancel}
            style={{ color: "red", marginRight: "20px" }}
          >
            ปิด
          </Button>

          <Button style={{ color: "green" }} htmlType="submit">
            บันทึก
          </Button>
        </div>
      </Form>
    );
  };

  return (
    <>
      <Modal
        title={`สร้างรายการเบิกเงินทดรองจ่าย`}
        open={open}
        onCancel={handleCancel}
        width={850}
        footer={null}
      >
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Card>{formDataSet()}</Card>
        </Spin>
        {isEditModal ? (
          <ExpenseList
            open={isEditModal}
            close={setIsEditModal}
            dataDefault={editPayment}
            handleEdit={handleUpdateDataEdit}
          />
        ) : null}
      </Modal>
    </>
  );
};
export default CreateAdvanePayment;
